<template>
  <div id="index">
    <dv-full-screen-container class="bg">
      <div class="host-body">
        <Menu name="video-monitor"
              @change="onProInfoChange($event)" />

        <dv-loading v-if="loading">Loading...</dv-loading>
        <div v-else
             id="content">
          <!-- 左边 -->
          <div id="left">
            <div class="leftMain">
              <div class="monitor-device-list-link flex-column align-center module"
                   style="position: relative; z-index: 1">
                <div class="monitor-device-item-link flex-row align-center"
                     v-for="item in menu"
                     v-bind:key="item.id"
                     v-bind:class="currentKey == item.id ? 'active' : ''"
                     v-on:click="makeActive(item.id)">
                  <div>
                    <span class="trans-o-left">{{ item.name }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="center">
            <div class="mapContainer"
                 :style="{
                backgroundImage: bgImg,
                backgroundSize: '100% 100%',
                backgroundRepeat: 'no-repeat',
              }">
              <div v-for="item in showDevices"
                   v-bind:key="item.Id"
                   v-bind:name="item.Name"
                   v-on:click="clickDevice(item)"
                   :style="{
                  left: (item.Pos ? item.Pos.Lat : 0) + 'px',
                  top: (item.Pos ? item.Pos.Lng : 0) + 'px',
                  position: 'absolute',
                }">
                <div v-if="item.DeviceMethod == 5">
                  <img v-bind:id="item.Id"
                       v-bind:name="item.Name"
                       v-bind:title="item.Name"
                       src="@/assets/image/position-tower.png"
                       class="position" />
                  <span v-bind:title="item.Name"
                        class="position">
                    {{ item.Name }}
                  </span>
                </div>
                <div v-else-if="item.DeviceMethod == 9">
                  <img v-bind:id="item.Id"
                       v-bind:name="item.Name"
                       v-bind:title="item.Name"
                       src="@/assets/image/position-elevator.png"
                       class="position"
                       :style="{
                      left: (item.Pos ? item.Pos.Lat : 0) + 'px',
                      top: (item.Pos ? item.Pos.Lng : 0) + 'px',
                    }" />
                  <span v-bind:title="item.Name"
                        class="position">
                    {{ item.Name }}
                  </span>
                </div>
                <div v-else-if="item.DeviceMethod == 6">
                  <img v-bind:id="item.Id"
                       v-bind:name="item.Name"
                       v-bind:title="item.Name"
                       src="@/assets/image/position-unloading.png"
                       class="position"
                       :style="{
                      left: (item.Pos ? item.Pos.Lat : 0) + 'px',
                      top: (item.Pos ? item.Pos.Lng : 0) + 'px',
                    }" />
                  <span v-bind:title="item.Name"
                        class="position">
                    {{ item.Name }}
                  </span>
                </div>
                <div v-else-if="item.DeviceMethod == 99">
                  <img v-bind:id="item.Id"
                       v-bind:name="item.Name"
                       v-bind:title="item.Name"
                       src="@/assets/image/position-led.png"
                       class="position"
                       :style="{
                      left: (item.Pos ? item.Pos.Lat : 0) + 'px',
                      top: (item.Pos ? item.Pos.Lng : 0) + 'px',
                    }" />
                  <span v-bind:title="item.Name"
                        class="position">
                    {{ item.Name }}
                  </span>
                </div>
                <div v-else-if="item.DeviceMethod == 3">
                  <img v-bind:id="item.Id"
                       v-bind:name="item.Name"
                       v-bind:title="item.Name"
                       src="@/assets/image/position-video.png"
                       class="position"
                       :style="{
                      left: (item.Pos ? item.Pos.Lat : 0) + 'px',
                      top: (item.Pos ? item.Pos.Lng : 0) + 'px',
                    }" />
                  <span v-bind:title="item.Name"
                        class="position">
                    {{ item.Name }}
                  </span>
                </div>
                <div v-else-if="item.DeviceMethod == 2">
                  <img v-bind:id="item.Id"
                       v-bind:name="item.Name"
                       v-bind:title="item.Name"
                       src="@/assets/image/position-evn.png"
                       class="position"
                       :style="{
                      left: (item.Pos ? item.Pos.Lat : 0) + 'px',
                      top: (item.Pos ? item.Pos.Lng : 0) + 'px',
                    }" />
                  <span v-bind:title="item.Name"
                        class="position">
                    {{ item.Name }}
                  </span>
                </div>
                <div v-else-if="item.DeviceMethod == 1">
                  <img v-bind:id="item.Id"
                       v-bind:name="item.Name"
                       v-bind:title="item.Name"
                       src="@/assets/image/position-door.png"
                       class="position"
                       :style="{
                      left: (item.Pos ? item.Pos.Lat : 0) + 'px',
                      top: (item.Pos ? item.Pos.Lng : 0) + 'px',
                    }" />
                  <span v-bind:title="item.Name"
                        class="position">
                    {{ item.Name }}
                  </span>
                </div>
                <div v-else-if="item.DeviceMethod == 21">
                  <img v-bind:id="item.Id"
                       v-bind:name="item.Name"
                       v-bind:title="item.Name"
                       src="@/assets/image/position-station.png"
                       class="position"
                       :style="{
                      left: (item.Pos ? item.Pos.Lat : 0) + 'px',
                      top: (item.Pos ? item.Pos.Lng : 0) + 'px',
                    }" />
                  <span v-bind:title="item.Name"
                        class="position">
                    {{ item.Name }}
                  </span>
                </div>

              </div>

              <div v-for="item in stationTags"
                   v-bind:id="item.Id"
                   :ref="item.Id+ `Ref`"
                   v-bind:key="item.Id"
                   v-bind:name="item.Name"
                   v-on:click="makeTagsChange(item)"
                   :style="{
                      position: 'absolute',
                      animation: `add-mapframes${item.Id} 1s linear `,
                      'animation-fill-mode':'forwards',
                    }">
                <div v-if="item.Distance">
                  <!-- <span style="width: 29.3562px; height: 29.3562px; margin-right: 6.98958px; transform: scale(1);margin-left: 5px; "></span>
                  <span style="transform: scale(0.931944);margin-left: 5px; ">{{item.LastDateTimeText}}</span>
                  <span style="transform: scale(0.931944); margin-left: 5px;">位于基站</span> -->
                  <span v-if="item.Direction == 0"
                        style="transform: scale(0.931944);margin-left: 5px; ">左侧</span>
                  <span v-else
                        style="transform: scale(0.931944); margin-left: 5px;">右侧</span>
                  <span style="transform: scale(0.931944); margin-left: 5px;">{{ item.Distance }}</span>
                  <span style="transform: scale(0.931944); margin-left: 5px;">米</span>
                </div>
                <img v-bind:id="item.Id"
                     v-bind:name="item.Name"
                     v-bind:title="item.Name"
                     src="@/assets/image/person2.png"
                     class="position" />
                <span v-bind:title="item.Name"
                      class="position">
                  {{ item.Name }}
                </span>
              </div>
            </div>
          </div>
          <!-- <div id="right"></div> -->
        </div>
      </div>
      <tower ref="tower"
             :parentObj="this"></tower>
      <elevator ref="elevator"
                :parentObj="this"></elevator>
      <unloading ref="unloading"
                 :parentObj="this"></unloading>
      <env ref="env"
           :parentObj="this"></env>
      <v-ideo ref="video"
              :parentObj="this"></v-ideo>
      <station ref="station"
               :parentObj="this"></station>
      <station-tag ref="stationTag"
                   :parentObj="this"></station-tag>
    </dv-full-screen-container>
  </div>
</template>

<script>
moment.locale("zh-cn");
import moment from "moment";
import ProInfoCache from "@/utils/cache/ProInfoCache";
import Menu from "@/components/Menu";
import tower from "./tower";
import elevator from "./elevator.vue";
import unloading from "./unloading.vue";
import env from "./env";
import VIdeo from "./video";
import station from "./station.vue";
import stationTag from "./stationTag.vue";
export default {
  data () {
    return {
      loading: true,
      visible: false,
      pro: {},
      connection: {},
      bgImg: "url(" + require("@/assets/image/morenditu.png") + ")",
      devices: {},
      showDevices: [],
      stations: [],
      stationTags: [],
      tempStationTags: [],
      menu: [],
      currentKey: 0,
    };
  },
  components: {
    Menu,
    tower,
    elevator,
    unloading,
    env,
    VIdeo,
    station,
    stationTag
  },

  created: function () {
    let connection = this.$op.getConnect(this);
    connection.on("uwblocation", (x) => {
      console.log(x)

      if (x.tagDevice == null || x.tagDevice == undefined) {
        console.log("uwblocation tagDevice is null")
        return
      }
      if (x.tagDevice.proId != this.pro.Id) {
        console.log("uwblocation tagDevice proId is not equal")
        return
      }
      let tagDevice = {
        Id: x.tagDevice.id,
        Name: x.tagDevice.name,
        ProId: x.tagDevice.proId,
        LastStationId: x.tagDevice.lastStationId,
        LastStationName: x.tagDevice.lastStationName,
        Distance: x.tagDevice.distance,
        Direction: x.tagDevice.direction,
        Code: x.tagDevice.code,
        Battery: x.tagDevice.battery,
        Type: x.tagDevice.type,
        LastDateTimeText: x.tagDevice.lastDateTimeText,
        Person: x.tagDevice.person,
      }

      this.calculationTagPos(tagDevice)
      let index = this.stationTags.findIndex(station => station.Id == tagDevice.Id);

      if (index == -1) {
        console.log("uwblocation tagDevice not found,push to tempStationTags")

        this.stationTags.push(tagDevice)
        this.stationTags = [...this.stationTags]
        this.$forceUpdate()
        return
      }
      this.stationTags[index] = tagDevice
      this.stationTags = [...this.stationTags]
      console.log(this.stationTags)
      this.$forceUpdate()
    });
  },
  mounted () {
    this.pro = ProInfoCache.getProInfo();
    this.initForm()
  },
  computed: {

  },
  watch: {},
  methods: {
    onProInfoChange (e) {
      this.pro = e;
      this.initForm()
    },
    initForm () {
      this.loadData();
    },
    loadData () {
      this.$http
        .post("/Projects/ProImage/GetTheProjectImageData", {
          ProId: this.pro.Id,
        })
        .then((resJson) => {
          this.loading = false;
          if (resJson.Success && resJson.Data)
            this.bgImg = "url(" + resJson.Data + ")";
        });
      this.fetchEventsList();
    },
    fetchEventsList () {
      if (!this.pro.Id) return;
      this.loading = true;
      this.$http
        .post("/DeviceManage/DeviceBase/GetDeviceSelfPosInfo", {
          ProId: this.pro.Id,
        })
        .then((resJson) => {
          this.loading = false;
          this.devices = resJson.Data;
          this.showDevices = this.devices;

          if (this.devices.some(ele => ele.DeviceMethod === 21))
            this.loadStationTags();
          this.initMenu();
        });
    },
    loadStationTags () {
      this.stationTags = [], this.stations = [];
      this.$http
        .post("/DeviceManage/DeviceStation/GetDeviceSelfPosInfo", {
          ProId: this.pro.Id,
        })
        .then((resJson) => {
          if (resJson.Success && resJson.Data) {
            this.stations = resJson.Data
            this.$http
              .post("/DeviceManage/DeviceStationTag/GetDataList", {
                Search: {
                  ProId: this.pro.Id,
                }
              })
              .then((resJson) => {
                if (resJson.Success && resJson.Data) {
                  this.stationTags = resJson.Data;
                  this.stationTags.forEach(element => {
                    this.calculationTagPos(element)
                  });
                }
              })
          }
        });
    },
    initMenu () {
      let arr = [];
      arr.push({ id: 0, name: "所有" });
      for (let index = 0; index < this.devices.length; index++) {
        const element = this.devices[index];
        arr.push({ id: element.DeviceMethod, name: element.DeviceMethodStr });
      }
      const res = new Map();
      this.menu = arr.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1));
    },
    calculationTagPos (tag) {
      if (!tag || !tag.LastStationId || !tag.Distance) {
        return;
      }
      let station = this.stations.find(station => station.Id == tag.LastStationId);
      if (!station || !station.Pos) return;
      tag.Pos = {}
      let lat = station.Pos.Lat;
      let lng = station.Pos.Lng;

      // 计算坐标点的相对距离
      let l = Math.sqrt(lat * lat + lng * lng)

      //Distance 为实际距离
      //l 为坐标点的相对距离
      let t = l * tag.Distance / station.Distance;

      //Direction 为方向 1 为左向 0 为右向
      let tagLat = tag.Direction == 0 ? lat - t : lat + t;
      // 计算坐标点的相对距离
      tag.Pos.Lat = tagLat;
      tag.Pos.Lng = lng;

      let tempTag = this.tempStationTags.find(tempTag => tempTag.Id == tag.Id);
      let tempLat = 0;
      if (tempTag) {
        let tempT = l * tempTag.Distance / station.Distance;
        tempLat = tempTag.Direction == 0 ? lat - tempT : lat + tempT;
      }
      let dymanicStyle = `@keyframes add-mapframes${tag.Id}{
                  from {
                      left: ${tagLat}+'px';
                  }
                  to {
                      left: ${tempLat + 'px'};
                }}`;
      let sheet = document.styleSheets[0]
      let position = sheet.insertRule(dymanicStyle, 0) //会返回添加的位置
      this.$nextTick(() => {
        setTimeout(() => {
          //清除动画和添加的样式
          setTimeout(() => {
            this.$refs[tag.Id + `Ref`][0].style.top = `${lng}px`
            this.$refs[tag.Id + `Ref`][0].style.left = `${tagLat}px`
            if (tagLat < 0 || tagLat > 1400)
              this.$refs[tag.Id + `Ref`][0].style.display = 'none'
            else
              this.$refs[tag.Id + `Ref`][0].style.display = 'block'
            sheet.deleteRule(position) //删除sheet样式表中添加的样式
          }, 1000);
        }, 200);
      });

      this.tempStationTags = [...this.stationTags];
    },
    makeTagsChange (x) {
      this.$refs.stationTag.openForm(x);
    },
    makeActive (key) {
      this.currentKey = key;
      if (this.currentKey == 0) this.showDevices = this.devices;
      else
        this.showDevices = this.devices.filter(function (item) {
          return item.DeviceMethod == key;
        });
    },
    clickDevice (d) {
      this.visible = true;
      switch (d.DeviceMethod) {
        case 2:
          this.$refs.env.openForm(d);
          break;
        case 3:
          this.$refs.video.openForm(d);
          break;
        case 5:
          this.$refs.tower.openForm(d);
          break;
        case 6:
          this.$refs.unloading.openForm(d); break;
        case 9:
          this.$refs.elevator.openForm(d); break;
        case 21:
          d = this.stations.find(station => station.Id == d.Id);
          this.$refs.station.openForm(d);
          break;
      }
    },
  },
};
</script>

<style lang="scss">
.danger {
  color: #fb497c !important;
}
.noml {
  color: #24e974 !important;
}
.huang {
  color: #ffb70e !important;
}
#content {
  display: flex;
  width: 100%;
  padding: 0.5rem 0.3rem 0 0.3rem;
  height: 10.3rem;
  overflow: hidden;
  h3 {
    font-weight: 900;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: rgb(249 242 242 / 85%);
  }
  #left {
    height: 100%;
    .leftMain {
      width: 2.14rem;
      background: url("../../assets/image/g_zuoxia.png") no-repeat center center;
      background-size: 100% 100%;
    }
  }

  #center {
    width: 1430px;
    height: 784px;
    margin-left: 1.4%;
  }

  #right {
    width: 22.22%;
    height: 100%;
    margin-left: 1.4%;
  }
}
.mapContainer {
  // width: auto;
  height: 100%;
  margin: 0 auto;
  background: #03263d;
  position: relative;
}
.monitor-device-item-link {
  cursor: pointer;
  background-color: rgb(15 19 37);
  margin: 0.025rem 0px;
  height: 0.35rem;
}
.active,
.monitor-device-item-link:hover {
  background-color: #1a5cd7;
}
.flex-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  display: -moz-box;
}
.align-center {
  align-items: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  text-align: center;
}
.trans-o-left {
  padding-left: 8.61111px;
  transform: scale(0.645833);
  font-size: 10.5px;
  color: hsla(0, 0%, 100%, 0.8);
  transform-origin: left center 0;
  -webkit-transform-origin: left center 0;
  -ms-transform-origin: left center 0;
}
.position {
  cursor: pointer;
  /*  position: absolute; */
  top: 179px;
  left: 661px;
  width: 40px;
  height: 40px;
  z-index: 1000;
  color: #fff;
  text-shadow: #000 1px 0 0, #000 0 1px 0, #000 -1px 0 0, #000 0 -1px 0;
  -webkit-text-shadow: #000 1px 0 0, #000 0 1px 0, #000 -1px 0 0, #000 0 -1px 0;
  -moz-text-shadow: #000 1px 0 0, #000 0 1px 0, #000 -1px 0 0, #000 0 -1px 0;
}
.align-center {
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
</style>
